'use client';

import Image, { ImageProps } from 'next/image';
import { imagekitLoader } from '@utils/imagekit-loader';

type ImagekitImageProps = Omit<ImageProps, 'loader'>;

/**
 * Client component wrapper for Next.js Image with ImageKit loader.
 * Required because custom loader functions cannot be passed across
 * the server/client component boundary.
 */
export function ImagekitImage({ alt, ...props }: ImagekitImageProps) {
  return <Image alt={alt} {...props} loader={imagekitLoader} />;
}
